import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import CustomButton from "../../components/Button/CustomButton";

const useStyles = makeStyles((theme) => ({
  marginTop: {
    marginTop: theme.spacing(5),
  },
}));

interface ProductEditCreateButtonsProps {
  create?: boolean;
  disabledConfirm: boolean;
  disabledDismiss: boolean;
  readonly?: boolean;
  handleDismissClick: () => void;
  handleConfirmClick?: () => void;
}

const ProductEditCreateButtons: React.FC<ProductEditCreateButtonsProps> = (props) => {
  const { create, disabledConfirm, disabledDismiss, readonly, handleConfirmClick, handleDismissClick } = props;
  const classes = useStyles();
  const confirmLabel = create ? "Create" : "Save and Close";

  return (
    <Grid className={classes.marginTop} container direction="row" justify="flex-end">
      {readonly ? (
        <CustomButton disabled={disabledDismiss} text="Close" onClick={handleDismissClick} />
      ) : (
        <CustomButton
          disabled={disabledConfirm}
          primary
          text={confirmLabel}
          type="submit"
          onClick={handleConfirmClick}
        />
      )}
    </Grid>
  );
};

export default ProductEditCreateButtons;
